/**
 * Service: departmentsApi
 */
angular.module('acme.common.service.departmentsApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('DepartmentsApiService', [ '$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/departments';
        return true;
      },

      list: function(props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }
        return $http({
          url: this.service.replace(/v1/, 'v2') + q,
          method: 'get'
        });
      },

      detail: function(id) {
        return $http({
          url: this.service + '/' + id,
          method: 'get'
        });
      },

      create: function(props) {
        return $http({
          url: this.service,
          method: 'post',
          data: {
            name: props.name
          }
        });
      },

      update: function(props) {
        return $http({
          url: this.service,
          method: 'put',
          data: {
            id: props.id,
            name: props.name
          }
        });
      },

      remove: function(id) {
        return $http({
          url: this.service + '/' + id,
          method: 'delete'
        });
      }

    };

}]);